import { Injectable } from '@angular/core';
import {BreakpointObserver, BreakpointState} from '@angular/cdk/layout';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  private _isMobile: BehaviorSubject<boolean> = new BehaviorSubject(this.isMobileByMediaMatch());
  public isMobile$: Observable<boolean> = this._isMobile.asObservable();

  public get isMobile() {
    return this._isMobile.value;
  }

  constructor(
    private breakpointObserver: BreakpointObserver
  ) {
    this.breakpointObserver
      .observe(`(max-width: 576px)`)
      .subscribe((state: BreakpointState) => {
        this.setIsMobile(state.matches);
      })
  }

  private setIsMobile(isMobile: boolean): void {
    this._isMobile.next(isMobile);
  }

  private isMobileByMediaMatch(): boolean {
    return this.breakpointObserver.isMatched(`(max-width: 576px)`);
  }
}
